/* Lucira Jewellery — theme scripts */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-header-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  /* ---------- Search toggle ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (!toggle) return;
    var panel = document.querySelector('[data-search-panel]');
    if (!panel) return;
    panel.classList.toggle('is-open');
    if (panel.classList.contains('is-open')) {
      var input = panel.querySelector('input');
      if (input) input.focus();
    }
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dots button');
    if (slides.length < 2) return;
    var index = 0;
    var timer;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }
    function next() { show(index + 1); }
    function start() { timer = setInterval(next, 5000); }
    function stop() { clearInterval(timer); }

    hero.querySelector('.hero__arrow--next').addEventListener('click', function () { stop(); next(); start(); });
    hero.querySelector('.hero__arrow--prev').addEventListener('click', function () { stop(); show(index - 1); start(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { stop(); show(n); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Product variant pills ---------- */
  document.querySelectorAll('[data-variant-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var group = pill.closest('[data-variant-group]');
      if (group) group.querySelectorAll('[data-variant-pill]').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var input = document.querySelector('[data-variant-id]');
      if (input && pill.dataset.variantValue) input.value = pill.dataset.variantValue;
    });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var counter = document.querySelector('[data-cart-count]');
          if (counter) counter.textContent = cart.item_count;
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1500);
        })
        .catch(function () { if (btn) { btn.textContent = original; btn.disabled = false; } });
    });
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WISH_KEY = 'lucira_wishlist';
  function wishGet() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; }
  }
  function wishSave(list) { localStorage.setItem(WISH_KEY, JSON.stringify(list)); updateWishCount(); }
  function wishHas(handle) { return wishGet().some(function (i) { return i.handle === handle; }); }
  function updateWishCount() {
    var n = wishGet().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }
  function markButtons() {
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      if (b.dataset.handle && wishHas(b.dataset.handle)) b.classList.add('is-wished');
      else b.classList.remove('is-wished');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.handle;
    if (!handle) return;
    var list = wishGet();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('is-wished');
    } else {
      list.push({
        handle: handle,
        title: btn.dataset.title || '',
        url: btn.dataset.url || ('/products/' + handle),
        image: btn.dataset.image || '',
        price: btn.dataset.price || ''
      });
      btn.classList.add('is-wished');
    }
    wishSave(list);
    renderWishlist();
  });

  function renderWishlist() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = wishGet();
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (i) {
      return '<div class="card">' +
        '<button class="card__wish is-wished" data-wish data-handle="' + i.handle + '" aria-label="Remove from wishlist">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7-4.35-9.5-8.5C.8 9.5 2 6 5.5 6 7.5 6 9 7 12 10c3-3 4.5-4 6.5-4C22 6 23.2 9.5 21.5 12.5 19 16.65 12 21 12 21z"/></svg></button>' +
        '<a href="' + i.url + '" class="card__media">' + (i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="card__body"><a href="' + i.url + '"><h3 class="card__title">' + i.title + '</h3></a>' +
        '<div class="card__foot"><span class="price">' + i.price + '</span></div>' +
        '<div class="card__actions"><a href="' + i.url + '" class="btn btn--gold btn--full">View Product</a></div></div></div>';
    }).join('');
  }

  updateWishCount();
  markButtons();
  renderWishlist();

  /* ---------- Share (native sheet, falls back to copy link) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.dataset.url || window.location.href;
    var title = btn.dataset.title || document.title;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    function copied() {
      var label = btn.getAttribute('aria-label');
      btn.classList.add('is-copied');
      btn.setAttribute('aria-label', 'Link copied');
      setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.setAttribute('aria-label', label);
      }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(copied).catch(function () { window.prompt('Copy this link:', url); });
    } else {
      window.prompt('Copy this link:', url);
    }
  });

  /* ---------- Product gallery: thumbnail -> main image ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-main-img]');
    var full = thumb.getAttribute('data-full');
    if (main && full) main.setAttribute('src', full);
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- Pincode delivery check (all India via India Post API) ---------- */
  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-pincode-input]');
    if (inp) inp.value = inp.value.replace(/[^0-9]/g, '').slice(0, 6);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pincode-check]');
    if (!btn) return;
    var wrap = btn.closest('[data-pincode]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-pincode-input]');
    var result = wrap.parentNode.querySelector('[data-pincode-result]');
    var pin = (input && input.value || '').trim();

    function show(msg, ok) {
      if (!result) return;
      result.hidden = false;
      result.textContent = msg;
      result.className = 'pincode-result ' + (ok ? 'is-ok' : 'is-error');
    }

    if (!/^[1-9][0-9]{5}$/.test(pin)) {
      show('Please enter a valid 6-digit pincode.', false);
      return;
    }
    show('Checking availability…', true);
    fetch('https://api.postalpincode.in/pincode/' + pin)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var d = data && data[0];
        if (d && d.Status === 'Success' && d.PostOffice && d.PostOffice.length) {
          var po = d.PostOffice[0];
          show('✓ Delivery available to ' + po.District + ', ' + po.State + ' — estimated 3–7 business days.', true);
        } else {
          show('Sorry, we could not verify this pincode. Please recheck the number.', false);
        }
      })
      .catch(function () {
        show('✓ We deliver all across India — estimated 3–7 business days.', true);
      });
  });

  /* ---------- Related products carousel arrows ---------- */
  document.querySelectorAll('[data-related]').forEach(function (rel) {
    var track = rel.querySelector('[data-related-track]');
    if (!track) return;
    function step() {
      var item = track.querySelector('.pdp-related__item');
      var w = item ? item.getBoundingClientRect().width + 20 : 240;
      return w * 2;
    }
    var prev = rel.querySelector('[data-related-prev]');
    var next = rel.querySelector('[data-related-next]');
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.style.display = track.scrollLeft > 2 ? 'flex' : 'none';
      if (next) next.style.display = track.scrollLeft < maxScroll ? 'flex' : 'none';
    }
    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  /* ---------- Mobile: reveal 2nd product image when card is centred on scroll ----------
     Desktop uses CSS :hover. Touch devices have no hover, so as the shopper scrolls
     the grid, whichever card sits in the middle band of the screen shows its 2nd image. */
  if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-alt', entry.isIntersecting);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    document.querySelectorAll('.card__media--has-hover').forEach(function (el) {
      cardObserver.observe(el);
    });
  }
})();
